module.exports = __webpack_public_path__ + "img/appBar.8ecd9f5a.png";